export enum ForecastQueries {
  Forecast = 'forecast',
}
